import { Component } from '@angular/core';
import { AuthService } from '../../auth/components/services/auth.service';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false,
})
export class MainLayoutComponent {
    constructor(public authService: AuthService) {}
}
